import { useState } from 'react'
import { ActionCardData, getActiveTagNames } from '@playbooks/action-cards-utils/src'
import { ActionCardModel } from '@playbooks/action-cards-utils/src'
import { ActionCardsElement } from '@playbooks/action-cards'

import { checkCompletionKeywords } from '../services/completionKeywordsService'
import { ON_ACTION_CARD_SAVE_EVENT } from '../constants'
import useMountEffect from './useMountEffect'

// This hook checks if the active tags (actionCardData.conditionalItems)
// match the completion keywords defined in the settings.
function useCompletionKeywordsMatch({
  completionKeywords,
  actionCardsElementRef,
}: {
  actionCardService: ActionCardModel | null
  completionKeywords: Set<string | null> | null
  actionCardsElementRef: React.RefObject<ActionCardsElement | null>
}) {
  const [completionKeywordsState, setCompletionKeywordsState] = useState(false)

  useMountEffect(() => {
    function adjustCompletionKeywordsState() {
      if (!actionCardsElementRef.current?.getValue() || !actionCardsElementRef.current) return

      const keywords = getActiveTagNames(actionCardsElementRef.current.getValue() as ActionCardData)

      setCompletionKeywordsState(checkCompletionKeywords(keywords, completionKeywords) ?? false)
    }

    adjustCompletionKeywordsState()

    window.addEventListener(ON_ACTION_CARD_SAVE_EVENT, adjustCompletionKeywordsState)
    return () => {
      window.removeEventListener(ON_ACTION_CARD_SAVE_EVENT, adjustCompletionKeywordsState)
    }
  })

  return completionKeywordsState
}

export default useCompletionKeywordsMatch
